<template>
  <div class="unselectable">
    <div class="subheading grey--text text--darken-1 mb-2">
      {{ $t('supportedFileFormats') }}
    </div>
    <v-layout
      :style="{'margin-left': $vuetify.breakpoint.smAndUp ? '-7px' : '-5px'}"
    >
      <img
        v-if="audio"
        src="/static/filetypes/mp3.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="audio"
        src="/static/filetypes/wav.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="image"
        src="/static/filetypes/png.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="image"
        src="/static/filetypes/jpg.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="image"
        src="/static/filetypes/pdf.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="video"
        src="/static/filetypes/mp4.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="video"
        src="/static/filetypes/mov.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
      <img
        v-if="video"
        src="/static/filetypes/m4v.svg"
        :height="$vuetify.breakpoint.xs ? 42 : 56"
        class="filetype-icon"
      >
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    audio: {
      type: Boolean,
      default: true,
    },
    video: {
      type: Boolean,
      default: true,
    },
    image: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.filetype-icon {
  margin-right: -4px;
}
</style>



// WEBPACK FOOTER //
// src/components/SupportedFileFormats.vue